import { ActionItem } from 'components/ActionItem';
import { localizable } from 'components/Localization';
import { observer } from 'mobx-react';
import React, { Component } from 'react';

// html output from string for dummies - as markdown etc. were too complicated to implement
const Formatter = ({ text }) => {
  const transformed = text.split('\n').reduce((acc, v) => {
    if (v.indexOf('- ') !== 0) return [...acc, { type: 'text', value: v }];

    const trimmed = v.substring(2);

    const { done, current } =
      acc.length > 0
        ? { done: acc.slice(0, acc.length - 1), current: acc[acc.length - 1] }
        : { done: [], current: undefined };

    if (!!current && current.type === 'bullets')
      return [...done, { type: 'bullets', value: [...current.value, trimmed] }];
    return [...acc, { type: 'bullets', value: [trimmed] }];
  }, []);

  const rendered = transformed.map(({ type, value }, i) => {
    if (type === 'text')
      return (
        <div
          key={i}
          style={{ paddingTop: '5px' }}
          dangerouslySetInnerHTML={{ __html: value }}
        ></div>
      );

    if (type === 'bullets')
      return (
        <ul key={i}>
          {value.map((a, i) => (
            <li key={i} dangerouslySetInnerHTML={{ __html: a }}></li>
          ))}
        </ul>
      );

    return <div key={i}></div>;
  });

  return rendered;
};

@observer
@localizable
export default class RoundItem extends Component {
  render() {
    const { t, round, theme, handleSelect, badges, costHighlight } = this.props;
    const badge =
      !badges || !badges.length
        ? undefined
        : [badges]
            .flat()
            .map((b) => t(`badge ${b}`))
            .join(t('badge_separator'));

    return (
      <ActionItem theme={theme} onClick={() => handleSelect(round)}>
        <div className="header">
          {badge ? <span className="badge">{badge}</span> : null}
          <h2>{t(`${round}_title`)}</h2>
          <div className="subtitle">{t(`${round}_subtitle`)}</div>
        </div>
        <div className="description">
          <div>
            <b>{t(`How it works`)}:</b>
          </div>
          <div>
            <Formatter text={t(`${round}_howItWorksPoints`)} />
          </div>
          <div>
            <b>{t(`When to use it`)}:</b>
          </div>
          <div>
            <Formatter text={t(`${round}_whenToUseItPoints`)} />
          </div>
          {t(`${round}_costs`) !== `${round}_costs` && (
            <div style={costHighlight ? { color: 'red' } : {}}>
              <b>{t(`Costs`)}:</b>
              <Formatter text={t(`${round}_costs`)} />
            </div>
          )}
        </div>
      </ActionItem>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/containers/Sale/Guides/Rounds/RoundItem.jsx